import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router';
import API from '../lib/api';

import { Center, Paper, Table, Anchor, Select, Group } from '@mantine/core';

// Generate last N days as dropdown options
function generateDayOptions(numDays) {
	const options = [{ value: '', label: 'All (Recent 50)' }];
	const today = new Date();
	
	for (let i = 0; i < numDays; i++) {
		const date = new Date(today);
		date.setDate(date.getDate() - i);
		const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
		const label = date.toLocaleDateString('en-US', { 
			weekday: 'short', 
			month: 'short', 
			day: 'numeric',
			year: 'numeric'
		});
		options.push({ value: dateStr, label });
	}
	
	return options;
}

export function NFPWatchPage() {
	const [recordings, setRecordings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedDate, setSelectedDate] = useState('');
	
	const dayOptions = useMemo(() => generateDayOptions(30), []);

	useEffect(() => {
		const fetchRecordings = async () => {
			setLoading(true);
			const params = selectedDate ? { date: selectedDate } : {};
			const r = await API.post('recording/getNfpRecordings', params);
			if (r.error) {
				console.error(r.error);
				setLoading(false);
				return;
			}
			setRecordings(r);
			setLoading(false);
		};
		fetchRecordings();
	}, [selectedDate]);

	const rows = recordings.map((rec) => (
		<Table.Tr key={rec._id}>
			<Table.Td>
				<Anchor component={Link} to={`/recording/${rec.filename}`}>
					{rec.filename}
				</Anchor>
			</Table.Td>
			<Table.Td>{new Date(rec.date).toLocaleString()}</Table.Td>
			<Table.Td>{rec.watermarkMatches}</Table.Td>
			<Table.Td>{rec.nfpMatches}</Table.Td>
		</Table.Tr>
	));

	return (
		<Center>
			<Paper w={1000} shadow="sm" p="md" m="md">
				<Group justify="space-between" mb="md">
					<div>
						<h1 style={{ margin: 0 }}>NFP Watch</h1>
						<p style={{ margin: 0, color: '#666' }}>
							{selectedDate ? `Recordings from ${selectedDate}` : 'Last 50 recordings with NFP data'}
						</p>
					</div>
					<Select
						label="Select Day"
						placeholder="Pick a day"
						data={dayOptions}
						value={selectedDate}
						onChange={setSelectedDate}
						searchable
						w={220}
					/>
				</Group>
				
				{loading ? (
					<Center><h2>Loading...</h2></Center>
				) : (
					<Table striped highlightOnHover>
						<Table.Thead>
							<Table.Tr>
								<Table.Th>Filename</Table.Th>
								<Table.Th>Date</Table.Th>
								<Table.Th>Watermark Matches</Table.Th>
								<Table.Th>NFP Matches</Table.Th>
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>
							{rows.length > 0 ? rows : (
								<Table.Tr>
									<Table.Td colSpan={4} style={{ textAlign: 'center' }}>
										No recordings found for this date
									</Table.Td>
								</Table.Tr>
							)}
						</Table.Tbody>
					</Table>
				)}
			</Paper>
		</Center>
	);
}
